import { Control, Controller } from 'react-hook-form';
import Zip from '@enerex/unified-ui-react/form/Zip';

type ZipInputProps = {
    name: string;
    validation?: Record<string, any>;
    control?: Control<any>;
    className?: string;
    disabled?: boolean;
    isInvalid?: boolean;
};

const formatZipCode = (value: string): string => {
    const cleaned = String(value || '').replace(/\D/g, '');

    if (cleaned.length >= 6) {
        return `${cleaned.slice(0, 5)}-${cleaned.slice(5, 9)}`;
    }

    return cleaned;
};

const ZipInput = ({
    name,
    validation,
    control,
    className,
    disabled,
    isInvalid
}: ZipInputProps) => {
    return (
        <Controller
            control={control}
            name={name}
            rules={validation}
            render={({ field: { onChange, value, onBlur } }) => (
                <Zip
                    value={value || ''}
                    onChange={(nextValue) => {
                        onChange(formatZipCode(String(nextValue || '')));
                    }}
                    onBlur={onBlur}
                    placeholder="XXXXX-XXXX"
                    className={className}
                    disabled={disabled}
                    invalid={isInvalid}
                />
            )}
        />
    );
};

export default ZipInput;
